import { render, staticRenderFns } from "./ReturnedGoodsOfUserFilter.vue?vue&type=template&id=cf931976&scoped=true"
import script from "./ReturnedGoodsOfUserFilter.vue?vue&type=script&lang=js"
export * from "./ReturnedGoodsOfUserFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf931976",
  null
  
)

export default component.exports